import React from 'react';
import { useParams } from 'react-router-dom';
import { ShortStoryView } from '.';
import { PracticeWidget } from '../Practice';
import PageContainer from '../layout/PageContainer';

const ShortStoryDetail = () => {
    const { id } = useParams();

    return (
        <PageContainer>
            <ShortStoryView storyId={id} />
            <PracticeWidget 
                contentType="ContentShortStory" 
                contentId={id} 
            />
        </PageContainer>
    );
};

export default ShortStoryDetail;
